import React, { Suspense } from 'react';
import { TextField, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { red } from '@material-ui/core/colors';
import Loader from './Loader';
import ConditionalWrapper from './ConditionalWrapper';

interface HtmlEditorProps {
  data?: string;
  onChange?: (html: string) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  textarea?: boolean;
}

const LexicalEditor = React.lazy(() => import('./lexical/LexicalEditor'));

const useStyles = makeStyles((theme: Theme) => ({
  errorWrapper: {
    border: `2px solid ${red[500]}`,
    borderRadius: theme.shape.borderRadius,
  },
}));

const HtmlEditor = ({
  data = '',
  placeholder = '',
  onChange,
  disabled = false,
  error = false,
  textarea = false,
}: HtmlEditorProps) => {
  const classes = useStyles();
  const isTextarea: boolean =
    textarea || document.body.classList.contains('form-pdf-view');

  if (isTextarea) {
    return (
      <TextField
        multiline
        rows={6}
        placeholder={placeholder}
        variant="outlined"
        defaultValue={data}
      />
    );
  }

  return (
    <Suspense fallback={<Loader inline />}>
      <ConditionalWrapper
        condition={error}
        wrapper={(children) => (
          <div className={classes.errorWrapper}>{children}</div>
        )}
      >
        <LexicalEditor
          data={data}
          placeholder={placeholder}
          onChange={onChange}
          disabled={disabled}
        />
      </ConditionalWrapper>
    </Suspense>
  );
};

export default HtmlEditor;
